/* eslint-disable @typescript-eslint/no-non-null-assertion */
export const APP_URL = process.env.NEXT_PUBLIC_APP_URL!
export const ADMIN_URL = process.env.NEXT_PUBLIC_ADMIN_URL!
export const SALESFORCE_URL = process.env.NEXT_PUBLIC_SALESFORCE_URL!
export const ONBOARDING_API_URL = process.env.NEXT_PUBLIC_ONBOARDING_API_URL!
export const BASE_PATH = process.env.NEXT_PUBLIC_BASE_PATH!
export const BUILD_ID = process.env.NEXT_PUBLIC_BUILD_ID!
export const ENV = process.env.NEXT_PUBLIC_ENV!
export const NEXT_PUBLIC_DATADOG_CLIENT_TOKEN =
    process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN!
export const IDP_BASE_URL = process.env.NEXT_PUBLIC_IDP_BASE_URL!
export const IDP_CLIENT_ID = process.env.NEXT_PUBLIC_IDP_CLIENT_ID!
export const IDP_AUDIENCE = process.env.NEXT_PUBLIC_IDP_AUDIENCE!
export const IDP_ENV = process.env.NEXT_PUBLIC_IDP_ENV!
export const SEGMENT_WRITE_KEY = process.env.NEXT_PUBLIC_SEGMENT_WRITE_KEY!
export const GITHUB_REF_NAME = process.env.NEXT_PUBLIC_GITHUB_REF_NAME!
export const GITHUB_REF_TYPE = process.env.NEXT_PUBLIC_GITHUB_REF_TYPE!
export const GITHUB_HEAD_REF = process.env.NEXT_PUBLIC_GITHUB_HEAD_REF!
export const DATADOG_RUM_CLIENT_TOKEN =
    process.env.NEXT_PUBLIC_DATADOG_RUM_CLIENT_TOKEN!
export const DATADOG_RUM_APPLICATION_ID =
    process.env.NEXT_PUBLIC_DATADOG_RUM_APPLICATION_ID!
export const DATADOG_RUM_SESSION_REPLAY_ENABLED =
    process.env.NEXT_PUBLIC_DATADOG_RUM_SESSION_REPLAY_ENABLED === "true"
export const DATADOG_RUM_ENABLED =
    process.env.NEXT_PUBLIC_DATADOG_RUM_ENABLED === "true"
export const OPTIMIZELY_KEY = process.env.NEXT_PUBLIC_OPTIMIZELY_KEY!
